import { Box, Collapse, IconButton, Typography } from '@mui/material';
import parse from 'html-react-parser';

const arrowRightActive = `${process.env.REACT_APP_BASE_URL}/img/static/arrow-right-white.svg`;
const arrowRight = `${process.env.REACT_APP_BASE_URL}/img/static/arrow-right-dark.svg`;

const descriptionTypographySx = (t) => ({
    color: '#4D4D4D',
    fontSize: '16px',
    fontWeight: 400,
    marginBottom: '16px',
    textAlign: 'center',
    lineHeight: '20px',
    [t.breakpoints.down(1200)]: {
        fontSize: '14px'
    },
    [t.breakpoints.down(900)]: {
        fontSize: '16px'
    }
});

const ServiceItem = ({ serviceName, description, url, isActive, handleActiveUpdate }) => (
    <Box
        component="a"
        href={url}
        sx={(t) => ({
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textDecoration: 'none',
            cursor: 'pointer',
            width: '300px',
            [t.breakpoints.down(1200)]: {
                width: '230px'
            },
            [t.breakpoints.down(900)]: {
                width: '300px'
            }
        })}
        onMouseEnter={handleActiveUpdate}
    >
        <Typography
            sx={(t) => ({
                color: '#6D6D6D',
                fontSize: '28px',
                fontWeight: 500,
                marginBottom: '16px',
                position: 'relative',
                cursor: 'pointer',
                '&::before': {
                    content: '""',
                    display: 'block',
                    height: isActive ? 15 : 0,
                    width: '120%',
                    position: 'absolute',
                    top: 25,
                    zIndex: -1,
                    background: 'linear-gradient(90deg, rgba(225, 92, 18, 0.8) 0%, rgba(252, 179, 54, 0.8) 100%);',
                    transitionProperty: 'height',
                    transitionDuration: 250,
                    transitionTimingFunction: 'ease',
                    margin: 'auto',
                    left: '-10%',
                    [t.breakpoints.down(900)]: {
                        top: 31,
                        height: 15
                    }
                },
                [t.breakpoints.down(1200)]: {
                    fontSize: '24px'
                },
                [t.breakpoints.down(900)]: {
                    fontSize: '28px',
                    fontWeight: 600
                }
            })}
        >
            {serviceName}
        </Typography>
        {/* Below md: CSS breakpoints match SSR — avoids Collapse closed→open CLS from useClientMediaQuery */}
        <Box sx={{ display: { xs: 'block', md: 'none' }, width: '100%' }}>
            <Typography sx={descriptionTypographySx}>{parse(description)}</Typography>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' }, width: '100%', minHeight: 'unset' }}>
            <Collapse in={isActive} mountOnEnter unmountOnExit={false}>
                <Typography sx={descriptionTypographySx}>{parse(description)}</Typography>
            </Collapse>
        </Box>
        <IconButton
            sx={(t) => ({
                transition: 'all 0.5s ease',
                borderWidth: 1,
                borderStyle: isActive ? 'none' : 'solid',
                borderColor: isActive ? 'unset' : '#6D6D6D',
                background: isActive ? 'linear-gradient(90deg, #E15C12 0%, #FCB336 100%);' : 'unset',
                '& path': {
                    fill: isActive ? '#FFFFFF' : '#6D6D6D'
                },
                '&:hover': {
                    borderColor: 'unset',
                    background: 'linear-gradient(90deg, #E15C12 0%, #FCB336 100%);'
                },
                [t.breakpoints.down(900)]: {
                    borderStyle: 'none',
                    background: 'linear-gradient(90deg, #E15C12 0%, #FCB336 100%);',
                    '& path': {
                        fill: '#FFFFFF'
                    }
                }
            })}
        >
            <Box
                component="img"
                alt={`${serviceName} button icon`}
                loading="lazy"
                src={isActive ? arrowRightActive : arrowRight}
                sx={{ width: '20px', height: '20px' }}
            />
        </IconButton>
    </Box>
);

export default ServiceItem;
